import { render } from "./TrixField.vue?vue&type=template&id=0ba633ee"
import script from "./TrixField.vue?vue&type=script&lang=js"
export * from "./TrixField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrixField.vue"]])

export default __exports__